import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { layoutModeTypes } from "../Components/constants/layout";
import logo2dark from '../assets/images/logo2-dark.png';
import logo2light from '../assets/images/logo2-light.png';
const Footer = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    // Remove the hardcoded mode logic - we'll use layoutModeType directly
    
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row className='mb-4'>
                        {/* <Col sm={6}>
                            {new Date().getFullYear()} © SeedNations.
                        </Col> */}
                        <Col sm={12}>
                            <div className="text-sm-center d-none d-sm-block">
                                <span className='mr-5'>Powered by  </span> 
                               {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                               <img height="15" className='ml-5' src={layoutModeType === layoutModeTypes.LIGHTMODE ? logo2light : logo2dark}></img> Seed  Nations
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;